import { render, staticRenderFns } from "./OrganizationsSelectField.vue?vue&type=template&id=1bc33f54&scoped=true&"
import script from "./OrganizationsSelectField.vue?vue&type=script&lang=js&"
export * from "./OrganizationsSelectField.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationsSelectField.vue?vue&type=style&index=0&id=1bc33f54&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc33f54",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
installComponents(component, {VAutocomplete})
